import { useCallback } from 'react';
import { useAuthService } from './AuthServiceContext';

const useRefresh = (): (() => Promise<void>) => {
  const authService = useAuthService();
  return useCallback(() => authService.refresh(), [authService]);
};

export default useRefresh;
